import React, { useContext, useEffect, useRef } from "react";
import { AuthContext } from "../../Context/AuthContext";
import { MenuContext } from "../../Context/Menucontext";
import { Link, useNavigate } from "react-router-dom";
import { useToast } from "../../Context/ToastContext"; 
import "./isauth.css";

const AuthDrop = () => {
  const { logout, profileData, role } = useContext(AuthContext);
  const { setIssAuthDrop, isauthDrop } = useContext(MenuContext);
  const { showToast } = useToast(); 
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const handleLogout = () => {
    logout();
    setIssAuthDrop(false);
    navigate("/"); 
    showToast("You have logged out successfully!", "success");
  };

  const userEmailPrefix = profileData?.email?.split("@")[0] || "";

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIssAuthDrop(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setIssAuthDrop]);

  return (
    <div 
      className="auth-drop-container" 
      ref={dropdownRef}
      style={{ display: isauthDrop ? "block" : "none" }}
    >
      <li>
        <h3>{userEmailPrefix}</h3>
        <p>{profileData?.email}</p>
      </li>
      {role === "vesselOwner" && (
        <>
          <li>
            <Link to="/dashboard/profile_v" onClick={() => setIssAuthDrop(false)}>Profile</Link>
          </li>
          <li>
            <Link to="/dashboard/create_vessel" onClick={() => setIssAuthDrop(false)}>Upload Vessel</Link>
          </li>
          <li>
            <Link to="/dashboard/myvessels" onClick={() => setIssAuthDrop(false)}>My Vessels</Link>
          </li>
          <li>
            <Link to="/vessel-order-history" onClick={() => setIssAuthDrop(false)}>Vessel Order History</Link>
          </li>
          <li>
            <Link to="/our_vessels" onClick={() => setIssAuthDrop(false)}>Chartering</Link>
          </li>
        </>
      )}

      {role === "charterer" && (
        <>
          <li className="desktop-pro">
            <Link to="/charterer-dashboard/updatecustomerprofile" onClick={() => setIssAuthDrop(false)}>Personal Info</Link>
          </li>
          <li>
            <Link to="/vessel-order-history" onClick={() => setIssAuthDrop(false)}>Vessel Order History</Link>
          </li>
          <li>
            <Link to="/our_vessels" onClick={() => setIssAuthDrop(false)}>Chartering</Link>
          </li>
        </>
      )}
      <li>
        <button onClick={handleLogout}>Sign out</button>
      </li>
    </div>
  );
};

export default AuthDrop;

